(function ($) {
    $(document).ready(function () {
        var wraps = $('.section.experiences_metadata');
        var destination = $('.section.main_content .below_the_title');
        if (destination.length) {
            wraps.each(function () {
                var wrap = $(this);
                var holder = wrap.find('.holder');
                if (holder.length) {
                    holder.children().appendTo(destination);
                }
            });
        }

        var breadcrumb = $('#breadcrumb .container');

        if (breadcrumb.length) {
            var holder_tags = wraps.eq(0).find('.holder_tags');
            if (holder_tags.length) {
                breadcrumb.addClass('breadcrumb_categories');
                holder_tags.children().appendTo(breadcrumb);
            }
        }

        if (location.href.indexOf('#!BookNow') !== -1) {
            if (window.history && window.history.pushState) {
                window.history.pushState('', '', window.location.pathname)
            } else {
                window.location.href = window.location.href.replace(/#.*$/, '#');
            }
            var scrollTop = wraps.eq(0).offset().top - $(window).height() * 0.3;
            $('html,body').animate({scrollTop: scrollTop});
        }
    });
})(jQuery);
